import { render } from "./BookSoonestAppointment.vue?vue&type=template&id=679c6be6&scoped=true"
import script from "./BookSoonestAppointment.vue?vue&type=script&lang=js"
export * from "./BookSoonestAppointment.vue?vue&type=script&lang=js"

import "./BookSoonestAppointment.vue?vue&type=style&index=0&id=679c6be6&lang=scss&scoped=true"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679c6be6"]])

export default __exports__